export default "__VITE_ASSET__b9d510ee__"